export default "__VITE_ASSET__bdfffdda__"